import React from 'react';
import { Film, Tv, User } from 'lucide-react';
import { motion } from 'framer-motion';
import './MediaTypeFilter.scss';

const filters = [
  { id: 'movie', label: 'Movie', icon: Film },
  { id: 'tv', label: 'TV Show', icon: Tv },
  { id: 'person', label: 'Person', icon: User },
];

export default function MediaTypeFilter({ currentSelection, onChange }) {
  return (
    <div className="filterTabs">
      <div className="filterTabs__inner">
        {filters.map((filter) => {
          const Icon = filter.icon;
          const isActive = currentSelection === filter.id;

          return (
            <button
              key={filter.id}
              type="button"
              onClick={() => onChange({ target: { value: filter.id } })}
              className={`filterTabs__btn ${isActive ? 'is-active' : ''}`}
            >
              {isActive && (
                <motion.span
                  layoutId="activeFilter"
                  className="filterTabs__pill"
                  transition={{ type: 'spring', bounce: 0.25, duration: 0.6 }}
                />
              )}

              <span className="filterTabs__content">
                <Icon className="filterTabs__icon" />
                <span className="filterTabs__label">{filter.label}</span>
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}